/**
 * Returns the browser "instance" bigQuery enrichment to be sent over each event.
 * @return {Object}
 */
const getInstanceEnrichment = () => (
    window.bigQueryEnrichment || {}
);

export default getInstanceEnrichment;
